// src/apis/featureFlags.ts
import axiosInstance from "../utils/axiosUtil";
import { baseURL } from "../utils/constants";
import { FeatureFlagsUpdate } from "../utils/types";

/**
 * GET /api/v1/featureflags/:hospitalId
 * Returns the single FeatureFlags object for the given hospital.
 */
export const getFeatureFlagsByHospitalId = async (
  hospital_id: string
)=> {
  try {
    const response = await axiosInstance.get( `${baseURL}/featureflags/${hospital_id}`);
    return response
  } catch (error: any) {
    if (error.response) {
      return error.response;
    } else {
      console.error("FeatureFlags API Error:", error);
      return { status: 500, data: { message: "Network error" } };
    }
  }
};

/**
 * PATCH /api/v1/featureflags/:hospitalId
 * Updates one or more flags; returns the updated flags object.
 */
export const patchFeatureFlagsByHospitalId = async (
  hospital_id: string,
  data: FeatureFlagsUpdate
) => {
  try {
    const response = await axiosInstance.patch(`${baseURL}/featureflags/${hospital_id}`,data);
    return response.data.result;
  } catch (error: any) {
    if (error.response) {
      console.error("FeatureFlags API Error:", error.response.status, error.response.data);
      return Promise.reject(
        new Error(error.response.data.message || "Failed to update feature flags")
      );
    }
    console.error("Unexpected API Error:", error);
    throw error;
  }
};
